var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "global-modal",
      class: {
        "global-modal--overmenu": _vm.overMenu,
        "global-modal--fullscreen": _vm.fullscreen,
        "global-modal--gray": _vm.bgColorGray,
      },
    },
    [
      _c(
        "div",
        { staticClass: "global-modal__content" },
        [
          _vm.hasHeader()
            ? _c(
                "div",
                { staticClass: "global-modal__header" },
                [
                  _c("global-button", {
                    staticClass:
                      "modal--close ignore-context button button--icon",
                    attrs: { icon: "close", theme: "secondary" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm._t("header"),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.$slots.header
            ? _c(
                "div",
                { staticClass: "global-modal__no-header" },
                [
                  _c("global-button", {
                    staticClass:
                      "modal--close ignore-context button button--icon",
                    class: { "button--opacity": _vm.fullscreen },
                    attrs: {
                      icon: "close",
                      theme: _vm.fullscreen ? "primary" : "ghost",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "global-modal__body" }, [_vm._t("body")], 2),
          _vm._v(" "),
          _vm.hasPagination()
            ? _c(
                "div",
                { staticClass: "global-modal__pagination" },
                [_vm._t("pagination")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasControls()
            ? [
                _c("div", { staticClass: "global-modal__devider" }),
                _vm._v(" "),
                _c("div", { staticClass: "global-modal__controls" }, [
                  _c(
                    "div",
                    { staticClass: "controls__left" },
                    [_vm._t("controls__left")],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "controls__center" },
                    [
                      _vm._t("controls__center"),
                      _vm._v(" "),
                      _vm._t("controls"),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "controls__right" },
                    [_vm._t("controls__right")],
                    2
                  ),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }